import { BANKS } from './const';

export const getBankFromCode = (code) =>
{
console.log('getBankFromCode', {code}, Object.values(BANKS), Object.values(BANKS).find(prefix => code?.toString().startsWith(prefix)))
 return Object.values(BANKS).find(prefix => code?.toString().startsWith(prefix)) ||
  BANKS.BS2
}

